import script from "./SocialRedirectPage.vue?vue&type=script&lang=ts"
export * from "./SocialRedirectPage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__